import XLSX from 'xlsx';
import dayjs from "dayjs";

import { useSystemPrompt } from "../../../hooks/useSystemPrompt";

import {
    productInjectionFields,
    useProduct,
} from "./model/useProduct"

import {
    itemInjectionProps,
    useProductItem
} from "./model/useProductItem"

import {
    markingInjectionProps,
    useMarking
} from "./model/useMarking"

import { getInjectionDataType } from '../utils/injectionSelection';

import { formatRoundValue } from '../utils/formatNumber';

let _excelHeader = [
    "No.",
    "#",
    "客人唛头",
    "供应商",
    "厂家联络",
    "SD单号",
    "厂家单号 / 快递号",
    "产品型号",
    "产品描述",
    "数量",
    "件数",
    "数量 / 件",
    "总件",
    "单价RMB",
    "总价RMB",
    "总金额",
    "宽CM",
    "长CM",
    "高CM",
    "立方",
    "总立方",
    "重量KG",
    "代付订金",
    "代付运费",
    "进仓日期",
    "签",
    "备注",
    "邮政编码",
    "装柜时间"
]

export function usePackingExcelExport({
    routeType
}) {

    const { promptMessage } = useSystemPrompt()

    const { listMarkings } = useMarking({ routeType })
    const { listProductItems } = useProductItem({ routeType })
    const { listProducts, sortProductsByGroupMarking } = useProduct({ routeType })

    const fetchBranches = async ({ branchIds }) => {

        try {

            const props = {
                limit: -1,
                skip: 0,
                filterValue: [
                    // {
                    //     name: 'id',
                    //     operator: filterOperatorTypes.anyOf,
                    //     value: JSON.stringify(branchIds)
                    // }
                ],
                sortInfo: {
                    id: "id",
                    dir: 0
                },
            }

            // props.branchType = branchTypes.customer

            // const result = await listBranches(props)
            const { data } = await listMarkings({
                props,
                markingIds: branchIds
            })

            // return result?.data?.branches ? result.data.branches : []
            return data

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

        return false

    }

    const fetchItems = async ({ itemIds }) => {

        try {

            const props = {
                limit: -1,
                skip: 0,
                filterValue: [
                    // {
                    //     name: 'id',
                    //     operator: filterOperatorTypes.anyOf,
                    //     value: JSON.stringify(itemIds)
                    // }
                ],
                sortInfo: {
                    id: "id",
                    dir: 0
                },
                // dataTypes: ["branch_marking"]
                // dataTypes
            }

            const { data } = await listProductItems({
                props,
                itemIds
            })

            // return result?.data?.items ? result.data.items : []
            return data

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

        return false

    }

    const fetchProducts = async ({ productIds }) => {

        try {

            const props = {
                limit: -1,
                skip: 0,
                filterValue: [
                    // {
                    //     name: 'id',
                    //     operator: filterOperatorTypes.anyOf,
                    //     value: JSON.stringify(productIds)
                    // }
                ],
                sortInfo: {
                    // id: "id",
                    id: productInjectionFields.loadContainerDateTime.retrieveKey,
                    dir: 0
                },
            }

            const { data } = await listProducts({
                props,
                productIds,
                dataTypes: [`${getInjectionDataType('product')}`, `${getInjectionDataType('item')}`]
            })

            // return result?.data?.products ? result.data.products : []
            return data

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

        return false

    }

    const _toDecimal0 = (val) => {
        // return parseFloat(val).toFixed(0)
        return formatRoundValue(val, 0).toFixed(0)
    }

    const _toDecimal2 = (val) => {
        // return parseFloat(val).toFixed(2)
        return formatRoundValue(val, 2).toFixed(2)
    }

    const _toDecimal3 = (val) => {
        // return parseFloat(val).toFixed(3)
        return formatRoundValue(val, 3).toFixed(3)
    }

    const _toDecimal4 = (val) => {
        // return parseFloat(val).toFixed(4)
        return formatRoundValue(val, 4).toFixed(4)
    }

    const getColsDefault = () => {

        let _width = {
            tiny: 5,
            short: 10,
            normal: 15,
            long: 30,
        }

        let cols = [
            { wch: _width.tiny }, // No
            { wch: _width.tiny }, // #
            { wch: _width.normal }, // 客人唛头
            { wch: _width.normal }, // 供应商
            { wch: _width.normal }, // 厂家联络

            { wch: _width.normal }, // SD单号
            { wch: _width.normal + 10 }, // 厂家单号 / 快递号
            { wch: _width.normal + 10 }, // 产品型号
            { wch: _width.normal + 10 }, // 产品描述
            { wch: _width.short }, // 数量

            { wch: _width.short }, // 件数
            { wch: _width.short }, // 数量 / 件
            { wch: _width.short }, // 总件
            { wch: _width.short }, // 单价RMB
            { wch: _width.short }, // 总价RMB

            { wch: _width.short }, // 总金额
            { wch: _width.short }, // 宽CM
            { wch: _width.short }, // 长CM
            { wch: _width.short }, // 高CM
            { wch: _width.short }, // 立方

            { wch: _width.short, t: 'n' }, // 总立方
            { wch: _width.short, t: 'n' }, // 重量KG
            { wch: _width.short, t: 'n' }, // 代付订金
            { wch: _width.short, t: 'n' }, // 代付运费
            { wch: _width.normal, t: "d" }, // 进仓日期

            { wch: _width.normal }, // 签
            { wch: _width.long }, // 备注
            { wch: _width.long }, // 邮政编码
            { wch: _width.long, t: "d" }, // 装柜时间

        ]

        // console.log('cols', cols)

        return cols
    }

    const buildTopSection = ({ data, items }) => {

        // total
        let totalCbm = items.reduce((total, item) => {
            total += parseFloat(item?.calculated?.totalCbm)
            return total
        }, 0)
        let totalPackQty = items.reduce((total, item) => {
            total += parseFloat(item?.calculated?.totalPackQty)
            return total
        }, 0)
        let totalValues = items.reduce((total, item) => {
            total += parseFloat(item?.calculated?.totalValues)
            return total
        }, 0)

        totalCbm = parseFloat(totalCbm).toFixed(3)
        totalPackQty = parseFloat(totalPackQty).toFixed(0)
        totalValues = parseFloat(totalValues).toFixed(2)

        let rawLinesHeader = [
            ["档案名称 : ", "", `Container Packing List 装柜单`],
            // "Container Packing List 装柜单 / 版本编号 : 39053"],
            ["创建时间 :  ", "", `${data?.ax_createdatetime} / 装柜日期 : ${data?.load_date} / 封号 : ${data?.number_seal}`],
            // "30-04 - 2024 11:04: 31 / 装柜日期 : 2024-04-03 / 封号 : IAAH070169"],
            ["货柜系统号 : ", "", `${data?.id} / 货柜柜号 : ${data?.repo_number} / 货柜备用号 : ${data?.number_alternative} / 货柜代号 : ${data?.number_marking}`],
            // "GZ00068367 / 货柜柜号 : IAAU1712920 / 货柜代号 : GZ / 4 / 26 - 3 / 4 / 24(8)"],
            [`清关公司 : `, ``, `${data?.custom_agent} / 中国货柜公司 : ${data?.shipper} / 监柜人: ${data?.supervisor}`],
            // "/ 中国货柜公司 : 卓宇 / 监柜人: 微"],
            ["备注 : ", "", `${data?.remark ? data.remark : "-"}`],
            // ""],
            ["总立方 : ", "", `CBM : ${totalCbm} / 总件数 : ${totalPackQty} / 总价 : ${totalValues}`],
            // "66.983 CBM / 总件数 : 375 / 总价 : 0"]
        ];

        return rawLinesHeader
    }

    const getTopSectionMerges = () => {

        let merges = [
            {
                s: { r: 0, c: 0 },
                e: { r: 0, c: 1 }, // e - start , r - row , c - column
            },
            {
                s: { r: 1, c: 0 }, // s - start , r - row , c - column
                e: { r: 1, c: 1 }, // e - start , r - row , c - column
            },
            {
                s: { r: 2, c: 0 }, // s - start , r - row , c - column
                e: { r: 2, c: 1 }, // e - start , r - row , c - column
            },
            {
                s: { r: 3, c: 0 }, // s - start , r - row , c - column
                e: { r: 3, c: 1 }, // e - start , r - row , c - column
            },
            {
                s: { r: 4, c: 0 }, // s - start , r - row , c - column
                e: { r: 4, c: 1 }, // e - start , r - row , c - column
            },
            {
                s: { r: 5, c: 0 }, // s - start , r - row , c - column
                e: { r: 5, c: 1 }, // e - start , r - row , c - column
            },
            {
                s: { r: 6, c: 0 }, // s - start , r - row , c - column
                e: { r: 6, c: 1 }, // e - start , r - row , c - column
            },
        ]

        return merges
    }

    const buildBodyHeader = () => {
        return [_excelHeader]
    }

    // const getSummary = ({ itemIds, dataItems }) => {

    //     // console.log('itemIdsitemIdsitemIdsitemIds', itemIds, dataItems)

    //     let selectedItems = dataItems.filter(i => {

    //         return itemIds.includes(i?.id)

    //     })

    //     // console.log('selectedItems', selectedItems)

    //     let totalWeight = selectedItems.reduce((total, item) => {
    //         total += parseFloat(item?.net_weight)
    //         return total
    //     }, 0)

    //     let totalCbm = selectedItems.reduce((total, item) => {
    //         total += parseFloat(item?.cbm) * parseFloat(item[itemInjectionProps.packQty.retrieveKey])
    //         return total
    //     }, 0)

    //     let totalPackQty = selectedItems.reduce((total, item) => {
    //         total += parseFloat(item[itemInjectionProps.packQty.retrieveKey])
    //         return total
    //     }, 0)

    //     let totalValues = selectedItems.reduce((total, item) => {
    //         total += parseFloat(item?.uom_price) * parseFloat(item[itemInjectionProps.handleQty.retrieveKey])
    //         return total
    //     }, 0)

    //     return {
    //         totalWeight,
    //         totalPackQty,
    //         totalCbm,
    //         totalValues
    //     }

    // }

    const buildBodySection = ({
        inputProducts,
        dataProducts,
        dataItems,
        dataBranches,
        isSimpleMode
    }) => {

        let data = []

        inputProducts.forEach((i1, index1) => {

            let items = i1?.items
            let productId = i1?.id
            let branchId = i1[productInjectionFields.customerBranchId.retrieveKey]
            let loadContainerDateTime = i1[productInjectionFields.loadContainerDateTime.retrieveKey]

            // get product full details
            let _p_ = dataProducts.filter(i => i.id === productId)
            let _p = _p_.length > 0 ? _p_[0] : {}

            // get the branches details
            let _b_ = dataBranches.filter(i => i.id === branchId)
            let _b = _b_.length > 0 ? _b_[0] : {}

            let postcodeDisplay = ''

            if (_b[markingInjectionProps.postcode.retrieveKey]) {
                let _postcodeDisplay = _b[markingInjectionProps.postcode.retrieveKey]
                // JSON.parse(_b[markingInjectionProps.postcode.retrieveKey])

                let arr = JSON.parse(_postcodeDisplay)

                // console.log('_postcodeDisplay', Array.isArray(arr), _postcodeDisplay, arr, productId)
                // postcodeDisplay = _postcodeDisplay
                // _postcodeDisplay.join(" / ")

                postcodeDisplay = arr.join(" / ")

            }

            // console.log('_b', _b)

            // get grand cbm total
            let summary = i1?.calculated
            let _iTotalCbm = summary?.totalCbm

            items.forEach((i2, index2) => {

                let itemId = i2?.id

                // get item full details
                let _i_ = dataItems.filter(i => i.id === itemId)
                let _i = _i_.length > 0 ? _i_[0] : {}

                // summary
                // let summary = getSummary({ itemIds: items.map(i => i?.item_id), dataItems })
                // console.log('summary', summary)

                // only for this row field
                let totalVal = parseFloat(_i[itemInjectionProps.handleQty.retrieveKey]) * parseFloat(_i.uom_price)

                // console.log('_i', _i)

                // make empty if index2 is more than 0
                let indexNoDisplay = index2 === 0 ? index1 + 1 : ''

                // check the checkin date time & createdatetime
                let checkinDateTime = `${_p?.ax_createdatetime}`

                if (_p[productInjectionFields.checkinDateTime.retrieveKey]) {
                    checkinDateTime = _p[productInjectionFields.checkinDateTime.retrieveKey]
                }

                // console.log('_p', _p, checkinDateTime)

                let itemData = [
                    (indexNoDisplay),
                    _p[productInjectionFields.paymentMethod.retrieveKey],
                    _p[productInjectionFields.customerMarking.retrieveKey],
                    _p[productInjectionFields.supplierName.retrieveKey],
                    _p[productInjectionFields.supplierContact.retrieveKey],
                    _p[productInjectionFields.companyPurchaseNumber.retrieveKey],
                    (
                        `${_p[productInjectionFields.supplierPurchaseNumber.retrieveKey]} / ${_p[productInjectionFields.courierTrackingNo.retrieveKey]}`
                    ),
                    // _p?.item_name,
                    // _p?.description,
                    _i?.item_remark,
                    _i?.item_description,

                    _toDecimal0(_i[itemInjectionProps.handleQty.retrieveKey]),
                    _toDecimal0(_i[itemInjectionProps.packQty.retrieveKey]),
                    _toDecimal0(_i[itemInjectionProps.qtyPerPackage.retrieveKey]),
                    _toDecimal0(summary?.totalPackQty),// 'totalPackQty',
                    _toDecimal2(_i.uom_price),

                    _toDecimal2(totalVal),// 'totalUomPrice',
                    _toDecimal2(summary?.totalValues),// 'grandUomPrice',

                    _toDecimal2(_i.dimension_length),
                    _toDecimal2(_i.dimension_width),
                    _toDecimal2(_i.dimension_height),

                    _toDecimal3(_i[itemInjectionProps.totalCbm.retrieveKey]),
                    _toDecimal3(_iTotalCbm),

                    _toDecimal4(_i[itemInjectionProps.totalWeight.retrieveKey]),

                    _toDecimal2(_p[productInjectionFields.prepayDepositFee.retrieveKey]),
                    _toDecimal2(_p[productInjectionFields.prepayTransportFee.retrieveKey]),

                    dayjs(checkinDateTime).format("YYYY-MM-DD"),
                    _p[productInjectionFields.signedByUserDisplay.retrieveKey],
                    _p[productInjectionFields.remark.retrieveKey],

                    postcodeDisplay,
                    loadContainerDateTime,

                ]

                // check is the simple mode enabled
                if (isSimpleMode === true) {

                    if (index2 === 0) { // only push at each items unique
                        data = [...data, itemData]
                    }

                } else { // full mode

                    if (index2 > 0) {
                        // console.log('itemData >> ', itemData[12])
                        itemData[1] = "" // for the #
                        itemData[2] = "" // for the 客人唛头
                        itemData[3] = "" // for the 供应商
                        itemData[4] = "" // for the 厂家联络
                        itemData[5] = "" // for the SD单号
                        itemData[6] = "" // for the 厂家单号 / 快递号
                        itemData[12] = "" // for the 总件
                        itemData[15] = "" // for the 总金额
                        itemData[20] = "" // for the 总立方
                        itemData[22] = "" // for the 代付订金
                        itemData[23] = "" // for the 代付运费
                        itemData[24] = "" // for the 进仓日期
                        itemData[25] = "" // for the 签
                        itemData[26] = "" // for the 备注

                    }

                    data = [...data, itemData]
                }


            })

        })

        return data
    }

    const getBodySectionMerges = ({
        offsetRowCount = 0,
        inputProducts,
        // dataProducts,
        // dataItems
    }) => {

        let merges = []

        let mergeColIndexNos = [
            // 0, // index
            1, // # payment type
            2, // customer marking
            3, // supplier Name
            4, // supplier contact
            5, // supplier purchase number
            6, // company purchase number / tracking no
            12, // total Pack qty,
            15, // grand total values
            20, // total cbm
            22, // prepay deposit
            23, // prepay transport fee
            24, // check in date
            25, // signed by
            26, // remark
        ]

        // let rowNo = offsetRowCount + 1

        let rowNo = 1 + offsetRowCount + 1

        inputProducts.forEach((i, index) => {

            let items = i?.items

            // console.log('items.lenght', items.length, rowNo)

            if (items.length > 1) {

                let startRow = rowNo
                let endRow = (rowNo + items.length - 1)

                let _merges = mergeColIndexNos.map(no => {
                    return {
                        s: { r: startRow, c: no }, // s - start , r - row , c - column
                        e: { r: endRow, c: no }, // e - end , r - row , c - column
                    }
                })

                merges = [...merges, ..._merges]

            }

            rowNo += items.length

        })

        // console.log('merges, merges', merges)

        return merges
    }

    // Function to set an entire column as a data type
    const setCellsDataTypes = ({ ws, fromRowNo, toRowNo, cols }) => {

        for (let i = fromRowNo; i < toRowNo; i += 1) {

            cols.forEach(i2 => {

                let cell = `${i2?.letter}${i}`

                // console.log('change', cell, 'to ', i2?.dataType)

                ws[cell].t = i2?.dataType

            })

        }

        // Object.keys(ws).forEach(cell => {
        //     if (cell.startsWith(colLetter) && !cell.startsWith('!')) {
        //         const cellRef = ws[cell];
        //         cellRef.t = dataType;
        //     }
        // });
    };

    // for export excel
    const generateExcel = async ({
        container,
        items,
        isSimpleMode = false,
        config = {
            generateFileName: ''
        }
    }) => {
        // console.log('items in hooks', items, container)

        /* array of arrays of data */

        // prepare the datasets
        let productIds = []
        items.forEach(i => {
            if (productIds.includes(i?.id) === false) {
                productIds.push(i?.id)
            }
        })

        let itemIds = []
        items.forEach(i => {
            i.items.forEach(i2 => {
                if (itemIds.includes(i2?.id) === false) {
                    itemIds.push(i2?.id)
                }
            })
        })

        let branchIds = []
        items.forEach(i => {
            if (branchIds.includes(i[productInjectionFields.customerBranchId.retrieveKey]) === false) {
                // console.log(`i`, i)
                branchIds.push(i[productInjectionFields.customerBranchId.retrieveKey])
            }
        })

        // console.log('branchIds', branchIds)

        let dataProducts = []

        if (productIds.length > 0) {

            dataProducts = await fetchProducts({ productIds })

            // have to sort by grouping the marking
            let a = sortProductsByGroupMarking({ products: dataProducts })

            dataProducts = a.finalProducts

        }

        let dataItems = []

        if (itemIds.length > 0) {
            dataItems = await fetchItems({ itemIds })
        }

        let dataBranches = []

        if (branchIds.length > 0) {
            dataBranches = await fetchBranches({ branchIds })
        }

        // console.log('dataBranches', dataBranches)
        // console.log('dataProducts', dataProducts)
        // console.log('dataItems', dataItems)

        let rawLines = []
        let merges = []

        let rawLinesHeader = buildTopSection({ data: container, items })
        let rawLinesBodyHeader = buildBodyHeader()
        let rawLinesBody = buildBodySection({
            inputProducts: items,
            dataProducts,
            dataItems,
            dataBranches,
            isSimpleMode
        })

        // console.log('rawLinesBodyHeader', rawLinesBodyHeader)
        // console.log('rawLinesBodyHeader', rawLinesBodyHeader)
        // console.log('rawLinesBody', rawLinesBody)

        rawLines = [...rawLines, ...rawLinesHeader]
        rawLines = [...rawLines, []] // break one line
        rawLines = [...rawLines, ...rawLinesBodyHeader]
        rawLines = [...rawLines, ...rawLinesBody]

        let mergesHeader = getTopSectionMerges()
        let mergesBody = getBodySectionMerges({
            offsetRowCount: rawLinesHeader.length,
            inputProducts: items,
            // dataProducts,
            // dataItems
        })

        // merges = [...merges, ...mergesHeader, ...mergesBody]
        merges = [...merges, ...mergesHeader]

        if (isSimpleMode === false) {
            merges = [...merges, ...mergesBody]
        }

        /* create worksheet */
        let ws = XLSX.utils.aoa_to_sheet(rawLines);
        /* create workbook and export */
        let wb = XLSX.utils.book_new();

        ws["!merges"] = merges
        ws["!cols"] = getColsDefault()

        // console.log('rawLinesHeader', rawLinesHeader.length, rawLinesBodyHeader.length, rawLinesBody.length)

        let fromRowNo = (rawLinesHeader.length + rawLinesBodyHeader.length) + 1 + 1
        let toRowNo = fromRowNo + rawLinesBody.length

        setCellsDataTypes({
            ws,
            fromRowNo,
            toRowNo,
            cols: [
                { letter: `J`, dataType: "n" },
                { letter: `K`, dataType: "n" },
                { letter: `L`, dataType: "n" },
                { letter: `M`, dataType: "n" },
                { letter: `N`, dataType: "n" },
                { letter: `O`, dataType: "n" },
                { letter: `P`, dataType: "n" },
                { letter: `Q`, dataType: "n" },
                { letter: `R`, dataType: "n" },
                { letter: `S`, dataType: "n" },
                { letter: `T`, dataType: "n" },
                { letter: `U`, dataType: "n" },
                { letter: `V`, dataType: "n" },
                { letter: `W`, dataType: "n" },
                { letter: `X`, dataType: "n" },
            ]
        })

        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        XLSX.writeFile(wb, `${config?.generateFileName}`);

        return {
            payload: {
                fileName: config?.generateFileName
            }
        }

    }

    return {
        generateExcel
    }

}